import { render, staticRenderFns } from "./SendMessageSlidebar.vue?vue&type=template&id=7002e6d4"
import script from "./SendMessageSlidebar.vue?vue&type=script&lang=js"
export * from "./SendMessageSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports